module.exports = __webpack_public_path__ + "img/cart-white.4746099c.svg";